
(function ($, document) {
    $(document).ready(function () {
        $('.js-fancy-dropdown').each(function () {
            var $component = $(this);
            var $label = $($component.data('fancy-dropdown-label'));
            var $options = $($component.data('fancy-dropdown-options'));
            var $result = $($component.data('fancy-dropdown-result'));

            $options.on('click', function (e) {
                e.preventDefault();
                var $currentOption = $(this);
                $result.val($currentOption.data('fancy-dropdown-value'));
                $label.text($currentOption.text());
            })
        });
    });
})(jQuery, document);